import { render, staticRenderFns } from "./admin-authorize.vue?vue&type=template&id=9ae93956&scoped=true&"
import script from "./admin-authorize.vue?vue&type=script&lang=js&"
export * from "./admin-authorize.vue?vue&type=script&lang=js&"
import style0 from "./admin-authorize.vue?vue&type=style&index=0&lang=css&"
import style1 from "./admin-authorize.vue?vue&type=style&index=1&id=9ae93956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae93956",
  null
  
)

export default component.exports